module.exports = {
  carData: () => {
    return {
      "IONIQ 5":{
        "EV-POWER": {
          "name": "IONIQ 5 EV-POWER",
          "showViews": true,
          "seatRows": 2,
        }
      },
      "TUCSON HEV":{
        "LIMITED": {
          "name": "TUCSON HEV LIMITED",
          "showViews": true,
          "seatRows": 2,
        }
      },
      // "PALISADE":{
      //   "SPORT": {
      //     "name": "PALISADE SPORT",
      //     "showViews": true,
      //     "seatRows": 3,
      //   }
      // },
      // "STARIA":{
      //   "LUJO": {
      //     "name": "STARIA LUJO",
      //     "showViews": true,
      //     "seatRows": 3,
      //   }
      // },
      "VENUE":{
        "LIMITED AT": {
          "name": "VENUE LIMITED AT",
          "showViews": true,
          "seatRows": 2,
        }
      },
      "HB20":{
        "ADVANCE": {
          "name": "HB20 ADVANCE",
          "showViews": true,
          "seatRows": 2,
        }
      },
      "HB20S":{
        "ADVANCE": {
          "name": "HB20S ADVANCE",
          "showViews": true,
          "seatRows": 2,
        }
      },
      // "CRETA":{
      //   "PREMIUM": {
      //     "name": "CRETA PREMIUM",
      //     "showViews": true,
      //     "seatRows": 2,
      //   }
      // },
      "KONA HEV":{
        "LIMITED": {
          "name": "KONA HEV LIMITED",
          "showViews": true,
          "seatRows": 2,
        }
      },
      "SANTA FE":{
        "HEV LIMITED 4x4": {
          "name": "SANTA FE HEV LIMITED 4x4",
          "showViews": true,
          "seatRows": 3,
        }
      },

      "GRAND i10":{
        "AT PREMIUM": {
          "name": "GRAND i10 AT PREMIUM",
          "showViews": true,
          "seatRows": 2,
        }
      },

      "PALISADE HEV":{
        "4x4": {
          "name": "PALISADE HEV 4x4",
          "showViews": true,
          "seatRows": 3,
        }
      },
      
    }
  }
}